import { Link } from 'react-router-dom'
import { Zap } from 'lucide-react'
import { Button } from '../ui/Button'

type Props = {
  open: boolean
  onClose: () => void
}

export function AiBoostExhaustedDialog({ open, onClose }: Props) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6 text-center">
        <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Zap className="w-7 h-7 text-amber-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">AI Boost Anda telah habis</h2>
        <p className="text-gray-600 mt-3 text-sm leading-relaxed">
          Silakan membeli AI Boost tambahan agar dapat melanjutkan menggunakan fitur AI.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            Tutup
          </Button>
          <Link to="/marketing/ai-boost" className="flex-1" onClick={onClose}>
            <Button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">
              Buka AI Boost Store
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export function isAiBoostExhausted(error: unknown): boolean {
  return Boolean(
    error &&
      typeof error === 'object' &&
      'code' in error &&
      (error as { code?: string }).code === 'AI_BOOST_EXHAUSTED'
  )
}
